import styled from 'styled-components';

const Faq = styled.span`
  font-size: 15px;
  color: #7a7a7a;
  font-weight: 700;
  margin: ${props => `${props.veticalSpace}px 0`};
`;

export default Faq;
